export const COUNTDOWN = 45;
export const apiUrl = process.env.NEXT_PUBLIC_BASE_API_URL;
